import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";

export function useMergeContact() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: { primaryId: string; secondaryId: string }) => {
      const result = await Contact.mergeContacts(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to merge contacts");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["contact"] });
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
    },
  });

  return {
    mergeContact: mutation.mutateAsync,
    isMerging: mutation.isPending,
  };
}
